export default __webpack_public_path__ + "static/media/btn-zeroback-stop-fr_fr@2x.ec1b400d.png";